module.exports = __webpack_public_path__ + "img/120.3.ea92b8a7.png";